import {useEffect,useState} from 'react';
import {apiFetch} from '../lib/api-client';
import {Dialog} from './controls';
import {JobTimesheets} from './JobTimeCards';
import type {JobTimeEntry} from './job-record-model';

export function OfficeJobTimeReview({jobId,technicianId,timezone,onClose,onSaved}: {jobId:string;technicianId:string;timezone:string;onClose:()=>void;onSaved:()=>void}) {
 const [page,setPage]=useState(1);
 const [version,setVersion]=useState(0);
 const [data,setData]=useState<{items:Array<JobTimeEntry & {jobStatus:string}>;total:number}|null>(null);
 const [error,setError]=useState('');
 useEffect(()=>{
  const controller=new AbortController();setData(null);setError('');
  const query=new URLSearchParams({jobId,technicianId,page:String(page),pageSize:'50'});
  void apiFetch(`/api/v1/workspace/timesheets?${query}`,{signal:controller.signal}).then(async response=>{
   const payload=await response.json();if(!response.ok) throw new Error(payload.error?.message || 'Unable to load job time.');
   if(!controller.signal.aborted) setData(payload.data);
  }).catch(cause=>{if(!controller.signal.aborted) setError(cause.message);});
  return ()=>controller.abort();
 },[jobId,technicianId,page,version]);
 return <Dialog title="Edit job time" onClose={onClose}>
  {error ? <p role="alert">{error}<button type="button" className="ml-3 underline" onClick={()=>setVersion(v=>v+1)}>Retry</button></p> : !data ? <p role="status">Loading time entries…</p> : <>
   <JobTimesheets payrollOnly entries={data.items} timezone={timezone} canEdit closed={['completed','cancelled','canceled'].includes(data.items[0]?.jobStatus)} onSaved={()=>{setVersion(v=>v+1);onSaved();}} />
   {data.total>50 && <div className="mt-4 flex justify-between"><button type="button" disabled={page===1} onClick={()=>setPage(p=>p-1)}>Previous</button><span>Page {page}</span><button type="button" disabled={page*50>=data.total} onClick={()=>setPage(p=>p+1)}>Next</button></div>}
  </>}
 </Dialog>;
}
